import React, { useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { Container, Row } from 'react-bootstrap'
import Slider from '../components/Slider';
import About from '../components/About';
import Gallery from '../components/Gallery';
import Contact from '../components/Contact'
import Card from '../components/Card';
import Donation from '../components/Donation';
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
import image1 from '../assets/images/image1.png'
import image2 from '../assets/images/image2.png'
import image3 from '../assets/images/image3.png'
import image4 from '../assets/images/image13.jpg'
import image5 from '../assets/images/image14.jpg'
import image6 from '../assets/images/image15.jpg'
import image7 from '../assets/images/image16.jpg'
import image8 from '../assets/images/image17.jpg'
import image9 from '../assets/images/image18.jpg'
import image10 from '../assets/images/image19.jpg'
import image11 from '../assets/images/image20.jpg'
import image12 from '../assets/images/image21.jpg'
import image13 from '../assets/images/image22.jpg'

const Homepage = () => {
  const location = useLocation();
  const pathname = location.pathname
  const hash = location.hash
  const key = location.key
  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  return (
    <div>
      <Slider />
      <About />
      <section id='gallery' className='text-center '>
        <Container className='gallery-container'>
          <h2 className='pt-5 pb-3'>Gallery</h2>
          <div className='d-flex align-items-center justify-content-center'>
            <Gallery />
          </div>
          <div className='pb-5 mt-5'><Link className="btn-primary" to="/gallery">View All<DoubleArrowRoundedIcon fontSize='small' /></Link></div>
        </Container>
      </section>
      <section id="mediaCoverage" className="mediaCoverage pt-4 pt-md-5">
        <Container>
          <div>
            <h2 className='centertext'>Media Coverage</h2>
          </div>
          <Row>
            <Card
              title="Temple build By Seva Sadhana"
              imageSrc={image1}
              imageAlt="Temple build By Seva Sadhana"
              description="Three villages completely developed by seva sadhana, having a small temple."
              enableImagePreview
            />

            <Card
              title="Homes for homeless"
              imageSrc={image2}
              imageAlt="Homes for homeless"
              description="Seva Sadhana provides home to homeless in remote area. Built concrete house from Bhunga."
              enableImagePreview
            />

            <Card
              title="Bhitara Village"
              imageSrc={image3}
              imageAlt="Bhitara Village"
              description="Kutchi Village build by Seva Sadhana in remote area of kutch."
              enableImagePreview
            />

            <Card
              title="Service Activities in Remote Villages of Kutch"
              imageSrc={image4}
              imageAlt="Service activities conducted by Seva Sadhana in remote villages of Kutch"
              description="Seva Sadhana organized various service activities in remote villages of Kutch, providing medical support, educational kits, and essential facilities to local residents."
              enableImagePreview
            />

            <Card
              title="Seva Sadhana’s Continuous Service Efforts in Kutch"
              imageSrc={image5}
              imageAlt="Seva Sadhana social service programs in Kutch"
              description="Through continuous dedication and service spirit, Seva Sadhana has been working relentlessly for social upliftment and community development across Kutch."
              enableImagePreview
            />

            <Card
              title="Comprehensive Service Initiatives Across Kutch Region"
              imageSrc={image6}
              imageAlt="Community development work by Seva Sadhana in Kutch"
              description="Seva Sadhana has extended its service initiatives across Kutch, focusing on education, healthcare, sanitation, and overall rural development."
              enableImagePreview
            />

            <Card
              title="Contribution to Developed India through Service"
              imageSrc={image7}
              imageAlt="Seva Sadhana contributing to nation building"
              description="Seva Sadhana continues to play an important role in nation-building by supporting housing, education, and welfare projects in underserved communities."
              enableImagePreview
            />

            <Card
              title="Women Empowerment Conference by Seva Sadhana"
              imageSrc={image8}
              imageAlt="Women empowerment conference organized by Seva Sadhana"
              description="On the occasion of National Service celebrations, Seva Sadhana organized a women empowerment conference to encourage leadership, self-reliance, and social participation."
              enableImagePreview
            />

            <Card
              title="Diwali Celebration with Underprivileged Families"
              imageSrc={image9}
              imageAlt="Diwali celebration with families in Kutch"
              description="Seva Sadhana celebrated Diwali with families from remote regions of Kutch, distributing essential items and spreading joy and togetherness."
              enableImagePreview
            />

            <Card
              title="Navratri Devotion and Cultural Activities in Kutch"
              imageSrc={image10}
              imageAlt="Navratri celebration and devotion activities by Seva Sadhana"
              description="During Navratri, Seva Sadhana organized devotional and cultural programs in remote villages, strengthening spiritual values and community unity."
              enableImagePreview
            />

            <Card
              title="Educational Support for Students through Donations"
              imageSrc={image11}
              imageAlt="Educational donation support by Seva Sadhana"
              description="Seva Sadhana received generous donations to support education, helping students from economically weaker backgrounds continue their studies."
              enableImagePreview
            />

            <Card
              title="Student Hostel Inauguration by Seva Sadhana"
              imageSrc={image12}
              imageAlt="Student hostel inaugurated by Seva Sadhana"
              description="A new student hostel was inaugurated by Seva Sadhana to provide better accommodation and learning facilities for students from rural areas."
              enableImagePreview
            />

            <Card
              title="Educational Infrastructure Development in Rapar"
              imageSrc={image13}
              imageAlt="Educational facilities developed by Seva Sadhana in Rapar"
              description="Seva Sadhana strengthened educational infrastructure in Rapar by developing hostels and study facilities to support students’ academic growth."
              enableImagePreview
            />
          </Row>

        </Container>
      </section>
      <Donation />
      <Contact />
    </div>
  )
}

export default Homepage;